import { useState, useEffect } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Layout.module.css";
import Avatar from "../../design-system/Avatar";
import SideBar from "./Sidebar";
import BottomNavBar from "./BottomNavBar";
import { Popover, PopoverHandler, PopoverContent, Button } from "@material-tailwind/react";
import { stringify } from "uuid";
import { ArrowRightOnRectangleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { APP_NAME, BaseURL } from "../../utils/appConstant";
import React from "react";
import { delete_user_data_from_client_side, getInitials } from "../../utils/common";
import { ToastContainer } from "react-toastify";

export function isTokenExpired(token: any) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );

    const payload = JSON.parse(jsonPayload);
    const currentTime = Date.now() / 1000;

    if (currentTime > payload.exp) {
        return true; // Token is expired
    } else {
        return false; // Token is not expired
    }
}

const Layout = () => {
    const [isSidebarVisible, setIsSidebarVisible] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [protectedStatus, setProtectedStatus] = useState(false);
    //console.log("location: ", location.pathname);
    let layOutTitle = "";
    if (location.pathname === "/" || location.pathname === "/workbench") {
        layOutTitle = "Workbench";
    }
    if (location.pathname.includes("interactiveCaseletGenerator") || location.pathname.includes("interaction")) {
        layOutTitle = "Interaction";
    } else if (location.pathname.includes("/my-exclusive-content")) {
        layOutTitle = "My Exclusive Content";
    } else if (location.pathname.includes("/citation-explorer")) {
        layOutTitle = "Prefetch Citation Explorer";
    } else if (location.pathname.includes("/caselets")) {
        layOutTitle = "Published Caselets";
    } else if (location.pathname.includes("/unpublished-caselets")) {
        layOutTitle = "Unpublished Caselets";
    } else if (location.pathname.includes("/engagement")) {
        layOutTitle = "Engagement";
    } else if (location.pathname.includes("/add-participant")) {
        layOutTitle = "Add Participant";
    } else if (location.pathname.includes("/unable-to-answer")) {
        layOutTitle = "Unable to Answer Analytics";
    } else if (location.pathname.includes("/activity-log")) {
        layOutTitle = "Prompts Analytics";
    } else if (location.pathname.includes("/like-dislike")) {
        layOutTitle = "Useful / Not useful / All Analytics";
    } else if (location.pathname.includes("/analytics")) {
        layOutTitle = "Analytics";
    } else if (location.pathname.includes("/source-weights")) {
        layOutTitle = "Source Weights";
    } else if (location.pathname.includes("/content-upload")) {
        layOutTitle = "Manage Content";
    }

    useEffect(() => {
        const handleResize = () => {
            setIsSidebarVisible(window.innerWidth >= 550);
        };
        window.addEventListener("resize", handleResize);
        window.addEventListener("load", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("load", handleResize);
            setIsSidebarVisible(true);
        };
    }, []);
    let userData: any = localStorage.getItem("user_data");
    if (userData) {
        try {
            userData = JSON.parse(userData);
        } catch (e) {
            console.error("Error parsing user_data from localStorage:", e);
            userData = null; // or set a default object if needed
        }
    } else {
        userData = null; // or set a default object if
        navigate("/user_login");
    }
    useEffect(() => {
        if (!userData) {
            delete_user_data_from_client_side();
            navigate("/user_login");
        }
    }, []);
    // Now, before accessing userData.picture, check if userData is not null
    const userPicture = userData ? userData.picture : null; // or a default picture
    const userName = userData ? userData.name : null;
    const emailId = userData ? userData.email : null;

    const handleLogout = async () => {
        console.log("navigate in layout : ", navigate("/user_login", { state: { logout: true } }));
    };
    const initials = getInitials(userName);
    return (
        <div className={`${styles.layout} w-full`}>
            <header className={`${styles.header} sticky top-0 z-50 w-full shadow-lg`} role={"banner"}>
                <div className={`${styles.headerContainer} h-16`}>
                    <Link to="/workbench" className={styles.headerTitleContainer}>
                        <h3 className={styles.headerTitle}>{APP_NAME} - Mentor</h3>
                    </Link>

                    <h3 className="font-bold text-green-800 truncate min-w-24">{layOutTitle}</h3>

                    <div className={`${styles.headerRightText} flex items-center pl-2 mr-2  rounded-xl h-16 `}>
                        <div className="min-w-24">
                            <img src="/favicon.png" className=" justify-self-end  h-20" />
                        </div>
                        <div className="min-w-10">
                            <Popover open={isPopoverOpen} handler={() => setIsPopoverOpen(!isPopoverOpen)} placement="bottom-end">
                                <PopoverHandler>
                                    <div className="cursor-pointer">
                                        {userPicture === null ? (
                                            <Avatar initials={initials} fullName={userName} />
                                        ) : (
                                            <img alt="Profile image" className="JZFjpd  rounded-full h-10 w-10" src={userPicture} title={userName}></img>
                                        )}
                                    </div>
                                </PopoverHandler>
                                <PopoverContent style={{ width: "80vw" }} className="m-2 z-20">
                                    <div className="flex justify-end">
                                        <button onClick={() => setIsPopoverOpen(false)}>
                                            <XMarkIcon className="w-6 h-6"> </XMarkIcon>
                                        </button>
                                    </div>
                                    <div className="mx-10">
                                        <div className="w-full flex items-center justify-center">
                                            <div aria-label="profile picture" className="w-2/3 flex items-center justify-center">
                                                {userPicture === null ? (
                                                    <Avatar initials={initials} fullName={userName} className="w-20 h-20 font-bold text-3xl" />
                                                ) : (
                                                    <img
                                                        alt="Profile image"
                                                        className="JZFjpd  rounded-full h-20 w-20"
                                                        src={userPicture}
                                                        title={userName}
                                                    ></img>
                                                )}
                                            </div>
                                        </div>
                                        <div className={` w-full flex items-center justify-center  rounded-xl`}>
                                            <h2 className="  text-xl">{userName}</h2>
                                        </div>
                                        <div className={` w-full flex items-center justify-center  rounded-xl`}>
                                            <h2 className="">{emailId}</h2>
                                        </div>
                                        <div
                                            className={` flex items-center justify-center rounded-xl border-2  mt-10 m-2 cursor-pointer z-auto`}
                                            onClick={handleLogout}
                                        >
                                            <ArrowRightOnRectangleIcon className="h-6 w-6"></ArrowRightOnRectangleIcon>
                                            <button className=" text-lg p-1 ">Sign out</button>
                                        </div>
                                    </div>
                                </PopoverContent>
                            </Popover>
                        </div>
                    </div>
                </div>
            </header>

            <div className="flex">
                <SideBar />
                <div className={`flex-1 text-m pl-20 pb-0 pt-16 pr-4 min-h-screen h-[100vh] w-full`}>
                    <Outlet />
                </div>
            </div>
            <ToastContainer toastStyle={{ marginTop: "8vh" }} />
        </div>
    );
};

export default Layout;
